import script from "./Table_Treatments.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_Treatments.vue?vue&type=script&setup=true&lang=js"

import "./Table_Treatments.vue?vue&type=style&index=0&id=101ee177&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101ee177"]])

export default __exports__